import { render } from "./RegisterStep1.view.vue?vue&type=template&id=d672dae2"
import script from "./RegisterStep1.view.vue?vue&type=script&lang=js"
export * from "./RegisterStep1.view.vue?vue&type=script&lang=js"

import "./RegisterStep1.view.vue?vue&type=style&index=0&id=d672dae2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__